import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../../services/modals.service';
import { VacationService } from '../../../services/vacation.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { closeModal } from '../../../shared/modal-functions';

@Component({
  selector: 'app-response-subscription',
  templateUrl: './response-subscription.component.html',
  styleUrls: ['../../../app.component.css']  
})
export class ResponseSubscriptionComponent implements OnInit {
  closeModal: any;
  @Input()
  trigger: string;
  @Input() 
  title: string;
  @Input() 
  body: string;
  @Input() 
  action: string;
  
  constructor(private modalService: ModalService, private subscriptionService: SubscriptionService, private vacationService: VacationService) { 
    this.closeModal = closeModal;
  }

  ngOnInit() {
  }

  close() {
    if (this.trigger === 'change-collection-type') {
      this.modalService.toggle('change-collection-type');
    }
    else if (this.trigger === 'schedule-vacation') {
      this.modalService.toggle('schedule-vacation');
    }
    this.closeModal('#responseSubscriptionModal');
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/response-subscription/response-subscription.component.ts